import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("language")
export class LanguageEntity {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "language", length: 100, default: () => "''" })
  language: string;
}
